const $button = $('.ds-header__menu-button-mobile');
const $menu = $('.mobile-menu');

$(function () {
  $button.on('click', function () {
    $menu.toggleClass('active');
    $('.ds-header').toggleClass('mobile-menu-active');
  });
});
